<template>
  <div class="main">
    <el-form
      ref="form" style="margin-top:10px"
      :model="formData"
      label-width="80px"
      @submit.native.prevent
      class="main-form"
      :show-message="false"
      >
    <el-form-item label="课件资源" required>
      <Uploadfile ref="Uploadfile" :uploadInfo="uploadInfo" @uploadres="uploadres" />
    </el-form-item>
    <el-form-item label="课件标题" prop="title"
        :rules="{ required: true, message: '课件标题', trigger: 'blur' }">
        <el-input
            placeholder="请输入"
            v-model="formData.title"
            maxlength="100"
            style="width: 50%"
            show-word-limit>
        </el-input>
    </el-form-item>
    <el-col :span="24">
    <el-form-item label="课程目录" prop="directoryId"
        :rules="{ required: false, message: '视频类型', trigger: 'blur' }">
        <el-cascader ref="cascader" style="width: 50%" :popper-append-to-body="false" popper-class="custom-dropdown"
          v-model="formData.directoryId"
          :show-all-levels="false" clearable filterable
          :props="props" :options="directoryList"
          @change="handleChange"
        ></el-cascader>
    </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="关键字" required prop="keys" :show-message="!formData.keys">
        <label-input @on-change="changeKey" :parentarr="getKey" ref="labelInput" />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="适合专业">
        <el-checkbox-group v-model="formData.profession" @change="updateProfessionName">
          <el-checkbox :label="val.id" v-for="val in professionData" :key="val.id">{{val.dictionaryName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-col>
    </el-form>
    <div class="btns">
      <div style="display:inline-block">
        <el-button type="primary" plain @click="close(true)">取消</el-button>
        <el-button
          type="primary"
          style="width:120px;margin-left: 10px"
          @click="submit(false)"
        >保存</el-button>
        <el-button v-if="!$route.query.id"
          type="primary"
          style="width:120px;"
          @click="submit('next')"
        >保存并下一题</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Uploadfile from '@/components/Uploadfile';
import { coursewareServer, courseServer, keyServer } from '@/api/api'
export default {
  components: {Uploadfile},
  computed: {
    getKey () {
      return this.formData.keys ? this.formData.keys.split(';') : []
    }
  },
  data () {
    return {
      props: {
        multiple: false,
        label: 'name',
        value: 'id',
        children: 'subList',
        checkStrictly: true,
        emitPath: false
      },
      uploadInfo: {
        tip: '支持后缀为.pptx或.ppt或.pdf的文件，且不超过100M',
        accept: '.pptx,.ppt,.pdf',
        multiple: false,
        fileList: [],
        fileSize: 100
      },
      professionData: [],
      directoryList: [],
      uploadData: {},
      formData: {
        title: '',
        directoryId: null,
        keys: '',
        filePath: null,
        originalFile: null,
        profession: [],
        professionName: ''
      }
    }
  },
  methods: {
    uploadres (res) {
      this.formData.filePath = res.response ? res.response.data.fileKey : null
      this.formData.originalFile = res.file ? res.file.name : null
    },
    getDetail () {
      coursewareServer.coursewareDetail({
        id: this.$route.query.id
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.formData = {
            title: data.title,
            type: data.type,
            directoryId: data.directoryId,
            keys: data.keys,
            filePath: data.filePath,
            profession: data.profession ? data.profession.split(',') : [],
            professionName: data.professionName
          }
          this.updateProfessionName()
          this.getfileurl([data.filePath])
          this.uploadInfo.fileList.push({key: data.filePath, name: data.originalFile})
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    async submit (isnext) {
      if (!this.formData.filePath) {
        this.$message.error('请上传文件!')
        return
      }
      let flag = await this.submitForm('form');
      if (!flag) {
        this.$message.error('请检查必填!')
        return
      }
      let obj = {
        profession: this.formData.profession.join(','),
        professionName: this.formData.professionName
      }
      if (this.$route.query.id) {
        coursewareServer.coursewareUpdate({
          id: this.$route.query.id,
          ...this.formData,
          ...obj
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.$message.success(message)
            this.close(false)
          } else {
            this.$message.error(message)
          }
        }).catch(error => {
          this.$message.error(error.response.data.message)
        })
        return
      }
      coursewareServer.coursewareAdd({
        ...this.formData,
        ...obj
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$message.success(message)
          if (isnext) {
            this.clearForm()
          } else {
            this.close(false)
          }
        } else {
          this.$message.error(message)
        }
      }).catch(error => {
        this.$message.error(error.response.data.message)
      })
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys: fileKeys.join()
      }).then(obj => {
        if (obj) {
          this.uploadInfo.fileList.forEach((e) => {
            if (e) {
              this.$set(e, 'url', obj[e.key] || '')
            }
          })
        }
      })
    },
    clearForm () {
      this.formData = {
        title: '',
        type: '',
        directoryId: null,
        keys: '',
        filePath: null,
        originalFile: null,
        profession: this.formData.profession,
        professionName: this.formData.professionName
      }
      this.uploadInfo.fileList = []
      this.$refs.Uploadfile.clearFormList()
    },
    submitForm (prop) {
      return new Promise((resolve) => {
        this.$refs[prop].validate((valid) => {
          if (valid) {
            resolve(true)
          } else {
            resolve(false)
          }
        });
      })
    },
    changeKey (v) {
      this.$set(this.formData, 'keys', v.join(';'));
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
    },
    // 课程目录
    selectData () {
      courseServer.profressionDirectory().then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.INITData(data)
          this.directoryList = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 专业数据
    selectDataV1 () {
      keyServer.profession({
        dictionaryKey: 'profession'
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.professionData = data
          if (!this.$route.query.id) {
            this.formData.profession = this.professionData.map(v => v.id)
            this.updateProfessionName()
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 更新 professionName 方法
    updateProfessionName() {
      const selectedIds = this.formData.profession;
      const names = this.professionData
        .filter(item => selectedIds.includes(item.id))
        .map(item => item.dictionaryName);
      this.formData.professionName = names.join(',');
    },
    INITData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].subList.length < 1) {
          data[i].subList = undefined // subList若为空数组，则将subList设为undefined
        } else {
          this.INITData(data[i].subList) // subList若不为空数组，则继续 递归调用 本方法
        }
      }
    },
    async close (flag) {
      if (flag) {
        this.$confirm('当前页未保存，是否确认继续', '提示', { type: 'warning' }).then(() => {
          window.close()
        })
      } else {
        window.close()
      }
    }
  },
  created () {
    this.selectData()
    this.selectDataV1()
    if (this.$route.query.id) {
      this.getDetail()
    }
  }
}
</script>

<style scoped lang='scss'>
.main{
  text-align: left;
  margin: 0px 10px;
}
.main-form {
  overflow: hidden;
  margin: 15px 0;
  padding: 15px 20px 0;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
}
.add-box {
  margin-bottom: 10px;
}
.btns{
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0px;
  line-height: 80px;
  background: #f9fbff;
  width: 100%;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/views/resource/page/addcourseIndex.vue